import { Group, Paper, Skeleton, Text, Tooltip } from "@mantine/core";
import { useRouteLoaderData } from "react-router-dom";
import { IconUsersGroup } from "@tabler/icons-react";
import ResellerInfo from "../../resellers/howto/ResellerInfo";
import CommunityUsersList from "../resellers/CommunityUsersList";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";

const TeamUsers = () => {
  const lang = useLanguage((s) => s.language);
  const team = useRouteLoaderData("team");
  const [tableLoading, setTableLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  return (
    <>
      <Group justify="space-between" mt={32} mb={16} gap={"xl"} align="strech">
        <Tooltip label={`${team.number_of_users} ${lang.white_labels.users}`}>
          <Paper p={"sm"}>
            <Group h={"100%"}>
              <IconUsersGroup color={"var(--mantine-color-primary-6)"} />
              <Text size="md" fw={600} c={"primary"}>
                {team.number_of_users}
              </Text>
            </Group>
          </Paper>
        </Tooltip>
        <ResellerInfo
          reseller={team}
          tableLoading={tableLoading}
          profile={profile}
          setProfile={setProfile}
        />
      </Group>

      {profile ? (
        <CommunityUsersList
          loading={tableLoading}
          setLoading={setTableLoading}
          profile={profile}
          setProfile={setProfile}
        />
      ) : (
        <Skeleton w={"100%"} h={"calc(100vh - 300px)"} />
      )}
    </>
  );
};

export default TeamUsers;
